import { TReduxActions } from '../../actions';
import { EListingOffersActionType, ELoadListingActionTypes } from '../../actions/listingOffers';
import { EAddToFavoritesActionTypes } from '../../actions/newFavorites/addToFavorite';
import { ERemoveFromFavoritesActionTypes } from '../../actions/newFavorites/removeFromFavorite';
import { EFetchStatus, IListingOffersState } from '../../types/listingOffers';

const OFFERS_PER_PAGE = 28;

const defaultSeoSchemas = {
  mortgageDiscount: '',
  onlineShow: '',
  organizationInfo: '',
  product: '',
  wideSelection: '',
};

export const defaultState: IListingOffersState = {
  offers: [],
  page: 1,
  maxOffersCount: OFFERS_PER_PAGE,
  currentOffersCount: 0,
  status: null,
  mlRanking: null,
  seoData: {
    markedList: { items: [] },
    seoSchemas: defaultSeoSchemas,
  },
  breadcrumbs: null,
  hasMoreOffers: false,
};

export function listingOffersReducer(
  state: IListingOffersState = defaultState,
  action: TReduxActions,
): IListingOffersState {
  switch (action.type) {
    case EListingOffersActionType.AddOffers: {
      const offers = [...state.offers, ...action.payload.offers];

      return {
        ...state,
        maxOffersCount: action.payload.offersCount,
        currentOffersCount: offers.length,
        offers,
        mlRanking: action.payload.mlRanking,
        hasMoreOffers: action.payload.offers.length >= OFFERS_PER_PAGE,
      };
    }
    case EListingOffersActionType.RemoveOffers: {
      return { ...state, maxOffersCount: OFFERS_PER_PAGE, currentOffersCount: 0, offers: [], mlRanking: null };
    }
    case EListingOffersActionType.SetPage: {
      return { ...state, page: action.payload };
    }
    case ELoadListingActionTypes.Request: {
      return { ...state, status: EFetchStatus.LOADING };
    }
    case ELoadListingActionTypes.Success: {
      const offers = [...state.offers, ...action.payload.offers];

      return {
        ...state,
        status: EFetchStatus.SUCCESS,
        maxOffersCount: action.payload.offersCount,
        currentOffersCount: offers.length,
        offers,
        mlRanking: action.payload.mlRanking,
        seoData: action.payload.seoData,
        breadcrumbs: action.payload.breadcrumbs,
        hasMoreOffers: action.payload.offers.length >= OFFERS_PER_PAGE,
      };
    }
    case ELoadListingActionTypes.Failure: {
      return { ...defaultState, status: EFetchStatus.FAILURE };
    }

    case ERemoveFromFavoritesActionTypes.Success:
    case EAddToFavoritesActionTypes.Success: {
      const { offerId, isFavorite } = action.payload;

      const offerToChangeIdx = state.offers.findIndex(offer => offer.id === offerId);

      if (offerToChangeIdx === -1) {
        return state;
      }

      const offers = state.offers.slice();
      offers[offerToChangeIdx] = { ...offers[offerToChangeIdx], isFavorite };

      return { ...state, offers };
    }
  }

  return state;
}
